import { HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';

export class VehicleAssignmentDTO{
    vehicleAssignId : number;
    assignedDate : Date;
    driverId: number;
    vehicleId : number;
    harvestingDate : Date;
    harvestingTime : HarvestingTime;
    indentId : number;
    createdUser?:string;
    updatedUser?:string;
    
    /**
     * 
     * @param vehicleAssignId 
     * @param assignedDate 
     * @param driverId 
     * @param vehicleId 
     * @param harvestingDate 
     * @param harvestingTime 
     */
    constructor(vehicleAssignId : number,
        assignedDate : Date,
        driverId: number,
        vehicleId : number,
        harvestingDate : Date,
        harvestingTime : HarvestingTime,indentId:number,createdUser?:string,
        updatedUser?:string){
        this.vehicleAssignId = vehicleAssignId;
        this.assignedDate = assignedDate;
        this.driverId= driverId;
        this.vehicleId= vehicleId;
        this.harvestingDate= harvestingDate;
        this.harvestingTime= harvestingTime;
        this.indentId= indentId;
        this.createdUser= createdUser;
        this.updatedUser= updatedUser;
    }
}
